import PageBuilder from '@commons/pagebuilder';
import { blocks } from '@commons/pagebuilder/blocks';
import { nodes } from '@commons/pagebuilder/nodes';
import { paragraphs } from '@commons/pagebuilder/paragraphs';
import { sections } from '@commons/pagebuilder/sections';
import { terms } from '@commons/pagebuilder/terms';
import { views } from '@commons/pagebuilder/views';
import { webforms } from '@commons/pagebuilder/webforms';

import { aiiaBlocks } from './blocks';
import { aiiaNodes } from './nodes';
import { aiiaTerms } from './terms';
import { aiiaViews } from './views';
import { aiiaWebforms } from './webforms';

/**
 * Registers the common and AiiA specific factories to the PageBuilder instance.
 *
 * IMPORTANT:
 * - This file should be imported once on the server and the client, to ensure the factories are registered in both environments.
 * - It should not have the 'use client' directive, as it is used in the server and client.
 */

PageBuilder.registerFactories({
  blocks: { ...blocks, ...aiiaBlocks },
  nodes: { ...nodes, ...aiiaNodes },
  paragraphs: { ...paragraphs },
  sections: { ...sections },
  terms: { ...terms, ...aiiaTerms },
  views: { ...views, ...aiiaViews },
  webforms: { ...webforms, ...aiiaWebforms },
});
